import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { PowerPlant } from '../../../../common/components/solar-calculation-result/model/power-plant';
import { SharedModule } from '../../../../common/shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { RouterLink } from '@angular/router';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { AnalysisService } from '../../../../services/analysis.service';
import { UserRole } from '../../../../common/models/user/user-role.enum';
import { PriceCountry } from '../../../../common/models/price/price';

@Component({
  selector: 'psc-power-plant-card',
  standalone: true,
  imports: [CommonModule, SharedModule, NgOptimizedImage, TranslocoModule, RouterLink],
  templateUrl: './power-plant-card.component.html',
})
export class PowerPlantCardComponent {

  @Input() powerPlant: PowerPlant;

  @Output() plantDeleted: EventEmitter<PowerPlant> = new EventEmitter<PowerPlant>();

  rowClass: string = 'flex gap-10 justify-between';
  rolesThatCanPlan: UserRole[] = [
    UserRole.ROLE_PERSONAL,
  ];

  constructor(
    private dialogService: DialogService,
    private analysisService: AnalysisService,
  ) {
  }

  /**
   * t(common-dialogs.confirm_delete)
   */
  deletePowerPlant(plantId: string) {
    this.dialogService.openConfirmDialog(() => {
        this.deletePlant(plantId);
      },
      () => {
      },
      'common-dialogs.confirm_delete');
  }

  private deletePlant(plantId: string) {
    this.analysisService.deletePowerPlant(plantId).subscribe(() => {
      this.plantDeleted.emit(this.powerPlant);
    });
  }

  protected readonly PriceCountry = PriceCountry;
}
